/* array-callback-return, consistent-return */
// We use this FILE both SSR and Clientside, so NO FLOW
// We want to have a clean state/reset state
// (['style', 'category', ...]) => { style: [], category: [], ...}
export const resetSelectedFacets = (facetNames) =>
  facetNames.reduce((results, facetName) => ({ ...results, [facetName]: [] }), {})

// We need to find out what `FacetName` a `AttributeName` belongs to
// Array#some -> escape as soon as TRUE || Return value
export const getFacetName = ({
  dictionary,
  name,
}: {
  dictionary: Record<string, Record<string, string>>
  name: string
}) => {
  let facetNameMatch = ''
  // Loop through all facets
  Object.entries(dictionary).some(([facetName, attributes]) => {
    // Loop through Attributes and look for a matching attributeName
    Object.keys(attributes).some((attributeName) => {
      if (attributeName === name) {
        // Set the FacetName & Escape
        facetNameMatch = facetName
        return facetNameMatch
      }
    })

    if (facetNameMatch) {
      // Found the Match & Escape
      return facetNameMatch
    }
  })
  return facetNameMatch
}

// Check Dictionary For Value OR return default (slugify) Value
// LOWER CASE NOW AS ALL VALUES ARE BEING LOWER CASE ON BACKEND FOR CONSTRUCTOR
const dictionaryLookup = ({ dictionary, facetName, facetValue }) => {
  return (
    (dictionary[facetName] && dictionary[facetName][facetValue]?.toLowerCase()) ||
    facetValue?.toLowerCase()
  )
}

// Turn Slug back to Natural Values in Algolia
export const convertSlugifiedFacetsToNaturalValues = ({ dictionary, slugifiedFacets }) => {
  const slugifiedResults = { ...slugifiedFacets }
  Object.entries(slugifiedFacets).forEach(([facetName, facetValue]) => {
    // Does the FacetName exist in dictionary, unslugify values
    if (dictionary?.[facetName]) {
      slugifiedResults[facetName] = Array.isArray(facetValue)
        ? facetValue.reduce(
            (list, name) => [
              ...list,
              dictionaryLookup({
                dictionary,
                facetName,
                facetValue: name,
              }),
            ],
            []
          )
        : dictionaryLookup({
            dictionary,
            facetName,
            facetValue,
          })
    }
  })
  return slugifiedResults
}
